import { schema } from "normalizr";
import { SchemaRecord } from "records/schema";

export const SchemaSchema = new schema.Entity(
    "schemas",
    {},
    {
        idAttribute: "_id",
    }
);

(SchemaSchema as any).record = SchemaRecord;
